import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectQueryFilters = (store: StoreSchema) => store.licenseUpdates.queryFilter
export const selectUpdateTimeFrom = (store: StoreSchema) => store.licenseUpdates.filter.updateTimeFrom
export const selectUpdateTimeTo = (store: StoreSchema) => store.licenseUpdates.filter.updateTimeTo